export default __webpack_public_path__ + "7f824dc1cc9c64b0d4c40fc56d79f939.svg";